import { getUsers, User } from 'api/user'
import { useEffect, useState, useCallback } from 'react'

type UserID = number
type SubGroup = Record<string, UserID[]>

export default function useUserSubGroup() {
  const [users, setUsers] = useState<User[]>([])
  const [subGroups, setSubGroups] = useState<SubGroup>({})
  const [userReady, setUserReady] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    // errors will be handled gobally
    getUsers().then((d) => {
      setUsers(d)
      setUserReady(true)
    })
  }, [])

  const updateSubGroups = useCallback(async (notFetchedNames: string[]) => {
    setSubGroups((sg) => {
      const newSG = { ...sg }
      notFetchedNames.forEach(async (name) => {
        const us = await getUsers({ subGroup: name })
        newSG[name] = us.map((u) => u.userID)
      })
      return newSG
    })
  }, [])

  const setReqGroupNames = useCallback(
    (reqGroupNames: Set<string>) => {
      const fetchedGrps = new Set(Object.keys(subGroups))
      const nonFetchedGroupNames = [...reqGroupNames].filter(
        (x) => !fetchedGrps.has(x),
      )
      if (nonFetchedGroupNames.length === 0) {
        return
      }
      // 初期設定をして他のeffectとの排他処理
      setSubGroups((sg) => {
        const newSG = { ...sg }
        nonFetchedGroupNames.forEach((name) => {
          newSG[name] = []
        })
        return newSG
      })
      // 以下時間かかる可能性がある
      setLoading(true)
      updateSubGroups(nonFetchedGroupNames)
        .catch(() => {
          throw new Error('failed to get groups info')
        })
        .finally(() => setLoading(false))
    },
    [subGroups, updateSubGroups],
  )

  return {
    ready: userReady && !loading,
    users,
    subGroups,
    setReqGroupNames,
  }
}
